import type { DocumentFromBackend, DocumentsFromBackend, TransformedDocument } from './types';

export function transformDocuments(
  documents: DocumentsFromBackend,
): TransformedDocument {
  const document = documents.data[0] || documents.data;

  if (!document) {
    return createDocument();
  }

  return createDocument(document.attributes);
}

function createDocument(
  attributes?: DocumentFromBackend['attributes'],
) {
  const content = attributes?.content || '';
  const name = attributes?.name || '';

  return { content, name };
}
